import { Link, useParams } from "react-router";
import { useSpotlights } from "../hooks/useSpotlights";
import { Spinner } from "../../SharedModule/components/Spinner";
import { ROUTE_PRODUCT_SPOTLIGHT } from "../../SharedModule/utils/constants";
import { PaginatedItems } from "../../SharedModule/components/PaginatedItems";
import { useEffect } from "react";
import image from "./../../styles/legacy/spotlight-off.png";
import { NoContent } from "../../SharedModule/components/NoContent";
import { BiLeftArrowAlt } from "react-icons/bi";
import Footer from "../../SharedModule/components/Footer";

export const SpotlightHistoryPage = () => {
  let { productId } = useParams();

  useEffect(() => {
    document.title = "The Hub - Spotlight History";
  }, []);

  const { spotlightHistory, isLoadingDataSpotlight, actualProductName } = useSpotlights(
    Number(productId)
  );

  const getUrlBack = (id: any) => {
    return ROUTE_PRODUCT_SPOTLIGHT.replace(":productId", id);
  };

  return (
    <>
      {isLoadingDataSpotlight && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {!isLoadingDataSpotlight && (
        <div className="content">
          <Link
            className="back-button-container text-decoration-none"
            style={{ width: "fit-content" }}
            to={getUrlBack(productId)}
          >
            <BiLeftArrowAlt className="back-button-arrow" />
            <span className="back-button-text">Back to Spotlight</span>
          </Link>
          <h2>{actualProductName} - Spotlight History</h2>
          {spotlightHistory && spotlightHistory.length > 0 && (
            <PaginatedItems
              itemsPerPage={10}
              items={spotlightHistory}
              type={"spotlight"}
            />
          )}
          {!spotlightHistory ||
            (spotlightHistory.length === 0 && (
              <>
                <NoContent
                  title="No Spotlight History"
                  image={image}
                  style={{ margin: "5% 25% 0 25%" }}
                />
                <Footer />
              </>
            ))}
        </div>
      )}
    </>
  );
};
